import React from 'react';
import { Link } from 'react-router-dom';

// import UserContext from '../UserContext';

import './WelcomePage.scss';

export class WsWelcomePage extends React.Component<
  { setLoginClicked: React.Dispatch<React.SetStateAction<boolean>> },
  any
> {
  // static contextType = UserContext;
  // context!: React.ContextType<typeof UserContext>;

  // getServicingEnvironment() {
  //   if (this.context.hasPermission('testing/vt1', 'read')) {
  //     return 'vt1';
  //   } else if (this.context.hasPermission('testing/vt6', 'read')) {
  //     return 'vt6';
  //   } else if (this.context.hasPermission('testing/ds10', 'read')) {
  //     return 'ds10';
  //   } else {
  //     return 'vt1';
  //   }
  // }

  render() {
    // let defaultEnvironmentId = '';
    // let defaultVersionId = '';

    // const defaultEnvironment = this.context.environments.find((environment: any) => environment.default);

    // if (defaultEnvironment) {
    //   defaultEnvironmentId = defaultEnvironment.id;

    //   const defaultVersion = defaultEnvironment.versions.find((version: any) => version.default);

    //   if (defaultVersion) {
    //     defaultVersionId = defaultVersion.id;
    //   }
    // }

    return (
      <div className='ws-welcome'>
        <div className='eg-login'>
          <div className='box'>
            <h1 className='title is-4'>Welcome to Decode</h1>
            {/* The Modern Vitesco Test Platform allows you to request virtual workplace clients for application testing on demand.<br />
            <br /> */}
            By clicking continue you will need to login using your work account.
            <br />
            <br />
            If this is the first time that you login, you will need to accept
            that Deliver gets the following information from your account:
            <ul>
              <li>Name</li>
              <li>E-Mail Address</li>
              <li>Photo</li>
            </ul>
            <br />
            <a
              onClick={(e) => {
                e.preventDefault();
                this.props.setLoginClicked(true);
              }}
              className='button is-medium'
              href='/continue'
            >
              Continue
            </a>
            {/* <Link to={`/login`} className="button is-medium">Continue</Link> */}
          </div>
        </div>
      </div>
    );
  }
}
